import generateKollectiveFetchFactory from '../interceptor/generateKollectiveFetchFactory';
import { Binder } from './bitmovin/interfaces';
import { FetchFactory } from '@kollective-frontend/ksdk-api';

const generateFetchFactory = (binder: Binder): FetchFactory => {
  let fetchFactory: FetchFactory;
  return async (url: RequestInfo, opts?: RequestInit): Promise<Response> => {
    const stack = binder.getOptions && binder.getOptions().stack;
    if (!stack || !binder.shouldIntercept || !binder.shouldIntercept()) {
      return fetch(url, opts);
    }
    if (!fetchFactory) {
      fetchFactory = generateKollectiveFetchFactory(stack);
    }
    return fetchFactory(url, opts);
  };
};

export default generateFetchFactory;
